import React from 'react'
import { useLanguage } from '../context/LanguageContext'
import { T } from './Translation'

const LoadingComponent = () => {
  const { language } = useLanguage()

  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="loading-spinner"></div>

        <div className="loading-hearts">
          <span className="loading-heart">💕</span>
          <span className="loading-heart">💖</span>
          <span className="loading-heart">💕</span>
        </div>

        <div className="loading-text">
          <T k="loading" />
        </div>

        <div className="loading-subtext">
          {language === 'he'
            ? 'טוען את פרטי האירוע...'
            : 'Loading event details...'}
        </div>
      </div>
    </div>
  )
}

export default LoadingComponent
